module.exports = __webpack_public_path__ + "img/CB4934_FB9971_F07554_F68464-256px.5d3e6dbd.png";